import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash/fp'

import * as profileReducer from '../../reducers/profile'
import * as authReducer from '../../reducers/auth'

import { useMutation } from 'react-apollo'
import gql from 'graphql-tag'
import ApolloClient from '../../apollo'

import { Slide } from '@material-ui/core'
import { Suggest } from '../Buddies'
import Open from '../Open/Welcome'
import SplitContainer from '../../components/SplitContainer'

const initSignupMutation = gql`
mutation($itemId: ID!) {
  signUpForMembership(input: {
    itemId: $itemId
  })
}
`

const bottomBars = ({
  buddies: {
    hideLeft: true,
    rightText: 'continue',
    loading: false
  },
  open: {
    leftText: 'skip',
    hideLeftIcon: true,
    rightText: 'join',
    leftColor: '#888888'
  }
})

const Welcome = (props) => {
  const [component, setComponent] = React.useState()
  const [bottomBarSetup, setBottomBarSetup] = React.useState({})
  const [initSignup, signupData] = useMutation(initSignupMutation, { client: ApolloClient })

  React.useEffect(() => {
    props.bootstrap()
    props.loadProfile()
  }, [props.loadProfile, props.bootstrap])

  const setOpen = React.useCallback(() => {
    const key = 'open'
    setComponent(key)
    setBottomBarSetup(_.get(key, bottomBars))
  }, [setComponent, setBottomBarSetup])

  const setBuddies = React.useCallback(() => {
    const key = 'buddies'
    setComponent(key)
    setBottomBarSetup(_.get(key, bottomBars))
  }, [setComponent, setBottomBarSetup])

  React.useEffect(() => {
    if (!_.isEmpty(props.profile)) {
      setBuddies()
    }
  }, [props.profile, setBuddies])

  const hasOpenMembership = React.useMemo(() => {
    const memberships = _.get('apolloUser.memberships', props.profile)
    const hasOpenMembership = _.reduce((inOpen, membership) => {
      const memId = _.get('membershipId', membership)
      const expiryDate = _.get('expiryDate', membership)
      return inOpen || (memId === 'GLFR_OPEN' && expiryDate <= Date.now())
    }, false, memberships)
    return hasOpenMembership
  }, [props.profile])

  const loading = React.useMemo(() => {
    if (component === 'open') {
      return _.get('loading', signupData)
    }
    return false
  }, [component, signupData])

  const handleNextStep = React.useCallback(async () => {
    if (component === 'open') {
      await initSignup({ variables: { itemId: 'GLFR_OPEN' } })
      props.history.replace('')
    } else if (component === 'buddies') {
      const seesOpen = false // TODO: reintroduce open? _.get('country_code', props.profile) === 'dk'
      if (!seesOpen || hasOpenMembership) {
        props.history.replace('')
      } else {
        setOpen()
      }
    }
  }, [component, initSignup, props.history, hasOpenMembership])

  const handleLeftClick = React.useCallback(() => {
    if (component === 'open') {
      props.history.replace('')
    }
  }, [props.history, component])

  return (
    <SplitContainer
      bottomBar={{
        loading,
        ...bottomBarSetup,
        onLeftClick: handleLeftClick,
        onRightClick: handleNextStep
      }}
    >
      <Slide
        in={component === 'buddies'}
        direction={component === 'buddies' ? 'left' : 'right'}
        unmountOnExit
      >
        <div>
          <Suggest
            skip={() => (component === 'buddies') && handleNextStep()}
            profile={props.profile}
          />
        </div>
      </Slide>
      {/* <Slide
        in={component === 'open'}
        direction={component === 'open' ? 'left' : 'right'}
        unmountOnExit
      >
        <div>
          <Open
            handleNextStep={handleNextStep}
            profile={props.profile}
          />
        </div>
      </Slide> */}

    </SplitContainer>
  )
}

export default _.compose(
  connect(
    (s, p) => ({
      profile: profileReducer.selectors.getProfile(s)
    }),
    (d, p) => ({
      loadProfile: () => d(profileReducer.actions.loadRequest(Date.now())),
      bootstrap: () => d(authReducer.actions.bootstrapRequest())
    }))
)(Welcome)
